"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StepConnector = _interopRequireDefault(require("./StepConnector"));
var _StepperWrapper = _interopRequireDefault(require("./StepperWrapper"));
var _excluded = ["isStatic", "light", "noEndConnector", "noInitialConnector", "noPadding"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var Stepper = function Stepper(_ref) {
  var isStatic = _ref.isStatic,
    light = _ref.light,
    noEndConnector = _ref.noEndConnector,
    noInitialConnector = _ref.noInitialConnector,
    noPadding = _ref.noPadding,
    props = _objectWithoutProperties(_ref, _excluded);
  var propsOrientation = props.orientation,
    children = props.children;
  var orientation = isStatic ? 'vertical' : propsOrientation;
  var childrenWithProps = _react.Children.map(children, function (child, index) {
    var isFirst = index === 0;
    var isLast = index === children.length - 1;
    return /*#__PURE__*/(0, _react.cloneElement)(child, {
      isStatic: isStatic,
      light: light,
      isFirst: isFirst,
      isLast: isLast,
      noEndConnector: noEndConnector,
      noInitialConnector: noInitialConnector,
      orientation: orientation,
      role: 'listitem',
      className: "".concat(noEndConnector ? 'noEndConnector' : '')
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_StepperWrapper["default"], _extends({
    connector: /*#__PURE__*/_react["default"].createElement(_StepConnector["default"], {
      light: light,
      isStatic: isStatic,
      orientation: orientation
    }),
    orientation: orientation,
    role: "list",
    noPadding: noPadding,
    light: light
  }, props), childrenWithProps);
};
Stepper.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].any,
  isStatic: _propTypes["default"].bool,
  light: _propTypes["default"].bool,
  noEndConnector: _propTypes["default"].bool,
  noInitialConnector: _propTypes["default"].bool,
  orientation: _propTypes["default"].oneOf(['horizontal', 'vertical']),
  noPadding: _propTypes["default"].bool
} : {};
var _default = exports["default"] = Stepper;